module.exports = __webpack_public_path__ + "static/media/1009260.7e12e249.png";